import { render, staticRenderFns } from "./EditNivel2.vue?vue&type=template&id=57e374a2&"
import script from "./EditNivel2.vue?vue&type=script&lang=js&"
export * from "./EditNivel2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports